// Days of the month (1 to 31)
// Labels are the day numbers, values are padded with leading zeros for days 1 through 9
const days = Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return { label: day.toString(), value: day < 10 ? `0${day}` : day.toString() };
});

// Months of the year (January to December)
// Labels are the month names, values are the numeric representation (1-12)
const months = [
    { label: "January", value: "01" },
    { label: "February", value: "02" },
    { label: "March", value: "03" },
    { label: "April", value: "04" },
    { label: "May", value: "05" },
    { label: "June", value: "06" },
    { label: "July", value: "07" },
    { label: "August", value: "08" },
    { label: "September", value: "09" },
    { label: "October", value: "10" },
    { label: "November", value: "11" },
    { label: "December", value: "12" },
];

// Years (current year and the 99 years prior)
// Labels and values are the same, just the year number
const currentYear = new Date().getFullYear();
const years = Array.from({ length: 100 }, (_, i) => {
    const year = currentYear - i;
    return { label: year.toString(), value: year.toString() };
});

export { days, months, years };  